<script setup lang="ts">
import type { PreparationStoryblok } from "~/types/storyblok";

const props = defineProps<{ blok: PreparationStoryblok }>();
useStoryblokSeo(props.blok);

const { search } = useProductSearch();

const productResponse = await search(props.blok.product as string, {
	criteria: {
		includes: {
			product_cross_selling: ["id", "name", "translated.name"]
		},
		associations: {
			crossSellings: {
				limit: 1,
				filter: [
					{
						type: "equals",
						field: "active",
						value: true
					}
				]
			},
			media: {},
			options: {},
			properties: {
				associations: {
					group: {}
				}
			}
		}
	}
});

const product = computed(() => {
	return productResponse.product;
});

if (props.blok.preparationOptions) {
	useRecipeJsonLD(product.value, props.blok);
}
</script>

<template>
	<div v-editable="blok" class="py-6">
		<Container>
			<StoryblokBreadcrumbs class="w-fit" />
			<h1 class="text-5xl font-brush leading-[3.125rem] my-4">
				{{ blok.title }}
			</h1>
			<PreparationWrapper :blok="blok" />
		</Container>
	</div>
</template>
